import React from "react";

export default function CheckoutSummary() {
  return <>CheckoutSummary</>;
}
